import { SelectorOption } from "../../../components/Redux/BasicSelector";

export const LogLevelOptions: SelectorOption[] = [
  { label: "None", id: "none" },
  { label: "Trace", id: "trace" },
  { label: "Debug", id: "debug" },
  { label: "Info", id: "info" },
  { label: "Warn", id: "warn" },
  { label: "Error", id: "error" },
];
